module.exports = __webpack_public_path__ + "static/media/sales.b449f6ef.png";